<div class="change-password-container">
  <form [formGroup]="passwordGroup">
  <kh-common-input #passwordInput [controlType]="inputTypes.Password" [placeholder]="'CHANGE_PASSWORD_INPUT.PASSWORD' | translate" [formControlName]="FORM_FIELDS.newPassword"></kh-common-input>
    <p class="requirement requirement--missing kh-small-text" *ngIf="showRequired">
       {{requiredMessage}} 
    </p>
    <kh-password-requirements [passwordFormControl]="getPasswordFormControl()"></kh-password-requirements>
  </form>
</div>
